module.exports = __webpack_public_path__ + "static/media/Purple_Timer@3x.704efa3d.png";